import { Heart } from "lucide-react";
import { CategoryBadge } from "./CategoryBadge";

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
  } catch {
    return "";
  }
};

export const MatchCard = ({ item }) => (
  <div className="match-card" data-testid="match-card">
    <div className="match-card-head">
      <CategoryBadge category={item.question.category} size="sm" />
      <span className="match-card-icon">
        <Heart size={16} strokeWidth={1.5} />
      </span>
    </div>
    <p className="match-card-text">{item.question.text}</p>
    <div className="match-card-date">{formatDate(item.createdAt)}</div>
  </div>
);

export default MatchCard;
